import { useState } from "react";
import { useParams } from "react-router-dom";
import Cohort from "cohorts/types/interfaces/cohort";
import { useFetcher } from "~/hooks/useFetcher";

const useCohort = () => {
  const { cohortId } = useParams();
  const [polling, setPolling] = useState(false);

  const resp = useFetcher<Cohort>(
    cohortId && cohortId !== "new" ? `/api/cohort-explorer/cohorts/${cohortId}` : null,
    {
      onSuccess: (data: Cohort) => {
        // Toggle long polling depending on if cohort has pending async queries or not
        // TODO: Replace this with WS once we've ironed out race condition and sticky session issues
        setPolling(data.pending_llm || data.pending_count);
      },
      revalidateOnFocus: false,
      refreshInterval: polling ? 1000 : 0,
    }
  );

  // Don't fetch a cohort when the cohortId is "new"
  // This is used to show a loading interstitial page while waiting for
  // backend response of creating new cohort from dataset page
  if (cohortId === "new") {
    return {
      data: undefined,
      isLoading: true,
      error: undefined,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      mutate: async () => {},
    };
  }

  return resp;
};

export default useCohort;
